import { PERSONALITY_MAX_BYTES, type PersonalityCard } from "@/types";

const encoder = new TextEncoder();

const clip = (value: string, length: number) => value.trim().replace(/\s+/g, " ").slice(0, length);

export function normalizePersonality(card: PersonalityCard): PersonalityCard {
  return {
    name: clip(card.name || "Nova", 24),
    voice: clip(card.voice || "warm and curious", 44),
    values: card.values.slice(0, 3).map((value) => clip(value, 20)),
    likes: card.likes.slice(0, 3).map((value) => clip(value, 20)),
    quirks: card.quirks.slice(0, 2).map((value) => clip(value, 28)),
    boundary: clip(card.boundary || "Respects consent and personal limits", 56),
    lore: clip(card.lore || "A newly awakened soul from the neon archive.", 120),
  };
}

export function personalityJson(card: PersonalityCard) {
  let normalized = normalizePersonality(card);
  let value = JSON.stringify(normalized);
  while (encoder.encode(value).length > PERSONALITY_MAX_BYTES && normalized.lore.length > 24) {
    normalized = { ...normalized, lore: normalized.lore.slice(0, -8) };
    value = JSON.stringify(normalized);
  }
  if (encoder.encode(value).length > PERSONALITY_MAX_BYTES) {
    normalized = { ...normalized, likes: normalized.likes.slice(0, 2), quirks: normalized.quirks.slice(0, 1) };
    value = JSON.stringify(normalized);
  }
  if (encoder.encode(value).length > PERSONALITY_MAX_BYTES) {
    throw new Error("Personality card is larger than 512 bytes.");
  }
  return value;
}

export function parsePersonality(value: string): PersonalityCard | null {
  try {
    return normalizePersonality(JSON.parse(value) as PersonalityCard);
  } catch {
    return null;
  }
}
